import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  all: [],
  pageGroups: [],
  totalCount: 0,
  currentPageNumber: 0,
  totalPageNumber: 0,
};

export default function groupReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GROUPS_FETCH:
      return {
        ...state,
        pageGroups: [...(payload?.data || [])],
        totalCount: payload?.total,
        currentPageNumber: payload?.currentPageNumber,
        totalPageNumber: payload?.totalPageNumber,
      };
    case ActionTypes.ALL_GROUPS_FETCH:
      return {
        ...state,
        all: [...(payload?.data || [])],
      };
    case ActionTypes.RESET_GROUPS_FETCH:
      return {
        ...state,
        all: [],
        pageGroups: [],
        totalCount: 0,
        currentPageNumber: 0,
        totalPageNumber: 0,
      };
    default:
      return state;
  }
}
